import * as types from './type'

const initialState = {
    loading: false,
    dataTrangThai: []
}

export const trangThaiDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_TRANG_THAI_DATA_START: 
            return {
                ...state,
                loading: true,
            }
        
        case types.GET_TRANG_THAI_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                dataTrangThai: action.payload
            }
        
        case types.GET_TRANG_THAI_DATA_ERROR:
            return {
                ...state,
                loading: false,
            }
        default:
            return state
    }
}